import {h, Fragment} from "preact"
import { usePagination, useActions } from "@nosto/preact"
import Icon from "./elements/Icon"

function PageLink({ onClick, href, className, ariaLabel, children }) {
    return (
        <a
            class={`ns-page-link ns-d-block ns-relative ns-text-undecorated ns-clickable ns-py-2 ns-px-4 ns-color-black ns-border-radius-3 ${className}`}
            href={href}
            aria-label={ariaLabel}
            onClick={onClick}
        >
            {children}
        </a>
    )
}

export default function Pagination() {
    const { prev, first, pages, last, next } = usePagination({
        width: 5
    })

    const { updateSearch, simulateUpdateSearch } = useActions()

    function pageLinkProps({ from }) {
        return {
            // Make the onClick handler an async function
            onClick: async e => {
                e.preventDefault()
                
                // 1. Await the updateSearch to ensure it completes
                await updateSearch({ products: { from } })
                
                // 2. After it's done, call nostojs to reload recommendations
                if (window.nostojs) {
                    nostojs(api => {
                        api.loadRecommendations();
                    });
                }
                
                // 3. Scroll to the top
                scrollTo(0, 0)
            },
            href: simulateUpdateSearch({ products: { from } }).url
        }
    }

    return (
        // ns-flex-wrap  ns-my-2 ns-mx-0
        <ul class="ns-d-flex ns-justify-content-center ns-align-items-center ns-m-0 ns-p-0 ns-list-unstyled">
            {prev && (
                <li>
                    <PageLink {...pageLinkProps(prev)} className="ns-pagination-arrow ns-previous" ariaLabel="Previous page">
                        {/* <Icon name="arrow" className="ns-page-prev-icon" /> */}
                        <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 6L20 12L14 18M19 12H4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                    </PageLink>
                </li>
            )}

            {first && (
                <>
                    <li>
                        <PageLink {...pageLinkProps(first)} ariaLabel="First page">
                            {first.page}
                        </PageLink>
                    </li>
                    {/* ns-px-4 */}
                    <li><span class="ns-d-block ns-py-2">...</span></li>
                </>
            )}

            {pages.map(page => (
                <li key={page.page} class={`${page.current ? "ns-active ns-color-black" : ""}`}>
                    <PageLink ariaLabel={`${page.page} page`} {...pageLinkProps(page)}>{page.page}</PageLink>
                </li>
            ))}

            {last && (
                <>
                {/* ns-px-4 */}
                    <li><span class="ns-py-2">...</span></li>
                    <li>
                        <PageLink {...pageLinkProps(last)} ariaLabel="Last page">{last.page}</PageLink>
                    </li>
                </>
            )}

            {next && (
                <li>
                    <PageLink {...pageLinkProps(next)} className="ns-pagination-arrow ns-next" ariaLabel="Next page">
                        {/* <Icon name="arrow" className="ns-page-next-icon" /> */}
                        <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 6L20 12L14 18M19 12H4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                    </PageLink>
                </li>
            )}
        </ul>
    )
}
